import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { AnimatePresence, motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../../rapid-ui'

interface RevokeInvitationDialogProps {
	isOpen: boolean
	email: string
	onClose: () => void
	onConfirm: () => void
	isRevoking: boolean
}

export function RevokeInvitationDialog({
	isOpen,
	email,
	onClose,
	onConfirm,
	isRevoking,
}: RevokeInvitationDialogProps) {
	const { t } = useTranslation('common')
	return (
		<AnimatePresence mode="popLayout">
			{isOpen && (
				<Dialog
					static={true}
					open={isOpen}
					onClose={onClose}
					className="relative z-50"
				>
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						className="fixed inset-0 bg-black/20 backdrop-blur-sm"
					/>
					<div className="fixed inset-0 w-screen overflow-y-auto">
						<div className="flex min-h-full items-center justify-center p-4">
							<DialogPanel
								as={motion.div}
								initial={{
									opacity: 0,
									scale: 0.95,
									transition: { duration: 0.2 },
								}}
								animate={{
									opacity: 1,
									scale: 1,
									transition: { duration: 0.2 },
								}}
								exit={{
									opacity: 0,
									scale: 0.95,
									transition: { duration: 0.2 },
								}}
								className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg ring-1 ring-grey-200/50"
							>
								<DialogTitle className="text-lg font-medium text-grey-900 mb-2">
									{t('revokeInvitation.title')}
								</DialogTitle>
								<p className="text-sm text-grey-700 mb-2">
									{t('revokeInvitation.confirmMessage', { email })}
								</p>
								<p className="text-sm text-grey-600 mb-6">
									{t('revokeInvitation.warning')}
								</p>
								<div className="flex gap-3 justify-end">
									<Button
										type="subtle"
										size="short"
										onClick={onClose}
										disabled={isRevoking}
									>
										{t('common.cancel')}
									</Button>
									<Button
										type="destructive"
										size="short"
										onClick={onConfirm}
										disabled={isRevoking}
									>
										{isRevoking
											? t('revokeInvitation.revoking')
											: t('revokeInvitation.revokeButton')}
									</Button>
								</div>
							</DialogPanel>
						</div>
					</div>
				</Dialog>
			)}
		</AnimatePresence>
	)
}
